import React, { useState, useEffect, useRef } from "react";

import { trackPromise } from "react-promise-tracker";
import { Modal, Form, Input, message, Avatar, Checkbox, Radio } from "antd";
import addMore from "../../../../assets/icons/addMore.png";
import services from "../../../../services";
import {
  alterarNoticacao,
  criarNotificacao,
  detalheNotificacoes,
} from "../../../../services/http/notificacoesService";
import Destinatarios from "./Destinatarios";
import "./styles.scss";
// idNotificacoesEdicao
import moment from "moment";
const NotificacaoForm = ({
  listarFavoritos,
  setTipoFormulario,
  idNotificacoesEdicao,
  fnlistaNotificacoesSino,
  moduloPortal,
  moduloGaleria,
}) => {
  const [checkBoxPortal, setCheckBoxPortal] = useState(false);
  const [checkBoxGaleria, setCheckBoxGaleria] = useState(false);
  const [checkBoxAgendamento, setCheckBoxAgendamento] = useState(false);
  const [dataHora, setDataHora] = useState({ data: "", hora: "" });
  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [usuarios, setUsuariosNotificacao] = useState([]);
  const [usuariosRemovidos, setUsuariosRemovidos] = useState([]);
  const [form] = Form.useForm();
  const [ordenacao, setOrdenacao] = useState("");
  const onSubmit = (value) => {
    if (value.titulo == undefined) {
      message.info("Informe o título");
      return;
    }
    if (value.subtitulo == undefined) {
      message.info("Informe o subtítulo");
      return;
    }

    if (usuarios.length === 0) {
      message.info("Informe um usuário");
      return;
    }

    function adicionarUmDia(data) {
      const dataObjeto = new Date(data);
      dataObjeto.setDate(dataObjeto.getDate() + 1);
      return dataObjeto.toISOString().split("T")[0]; // Retorna apenas a parte da data (sem a parte da hora)
    }

    function formatarDataHora(data, hora) {
      var dataObjeto = moment(`${data}T${hora}`);
      return dataObjeto.format();
    }

    if (checkBoxAgendamento && dataHora.hora == "") {
      message.info("Informe a hora");
      return;
    }
    if (checkBoxAgendamento && dataHora.data == "") {
      message.info("Informe a data");
      return;
    }

    const data = {
      titulo: value.titulo,
      subtitulo: value.subtitulo,
      dataAgendadaLocal:
        checkBoxAgendamento == true
          ? formatarDataHora(dataHora.data, dataHora.hora)
          : null,
      agendaRadio: checkBoxAgendamento,
      link: value.link ? value.link : null,
      portalCheckbox: checkBoxPortal,
      galeriaCheckbox: checkBoxGaleria,
      usuarios: ObterIdsUsuarioParaNotificacao(),
    };

    if (idNotificacoesEdicao == null) {
      trackPromise(criarNotificacao(data)
        .then(res => {
          if (res.fail) {
            message.warning(res.errors.message);
          }
          else {
            message.success("Notificação criada com sucesso");
            listarFavoritos();
            setTipoFormulario(null);
            fnlistaNotificacoesSino();
          }
        }));
    } else {
      trackPromise(alterarNoticacao(idNotificacoesEdicao, data)
        .then(res => {
          if (res.fail) {
            message.warning(res.errors.message);
          }
          else {
            message.success("Notificação editada com sucesso");
            listarFavoritos();
            setTipoFormulario(null);
            fnlistaNotificacoesSino();
          }
        }));
    }
  };

  const ObterIdsUsuariosRemovidosNotificacoes = () => {
    let listaIdsUsuariosRemovidos = [];
    usuariosRemovidos.forEach((element) => {
      listaIdsUsuariosRemovidos.push(element.id);
    });

    return listaIdsUsuariosRemovidos;
  };

  const ObterIdsUsuarioParaNotificacao = () => {
    let listaIdsUsuarios = [];
    usuarios.forEach((element) => {
      listaIdsUsuarios.push({ id: element.id });
    });

    return listaIdsUsuarios;
  };

  function inverterDataHora(dataHoraString) {
    var dataHoraObjeto = moment.utc(dataHoraString).local();
    const dataFormatada = dataHoraObjeto.format("YYYY-MM-DD");
    const horaFormatada = dataHoraObjeto.format("HH:mm");

    setDataHora({ data: dataFormatada, hora: horaFormatada });
  }

  const listaNotificacoes = () => {
    trackPromise(
      detalheNotificacoes(idNotificacoesEdicao)
        .then((res) => {
          inverterDataHora(res.data?.dataEnvioUtc);
          setCheckBoxAgendamento(res.data.agendaRadio);
          setCheckBoxPortal(res.data?.portalCheckbox);
          setCheckBoxGaleria(res.data?.galeriaCheckbox);
          var lista = res.data?.usuarios.map((e) => ({
            ...e,
            checked: false,
          }));
          setUsuariosNotificacao(lista);
          form.setFieldsValue({
            ["titulo"]: res.data?.titulo,
            ["subtitulo"]: res.data?.subtitulo,
            ["link"]: res.data?.link,
            ["portalCheckbox"]: res.data?.portalCheckbox,
            ["galeriaCheckbox"]: res.data?.galeriaCheckbox,
          });
        })
        .catch((error) => {
          console.error(error.message);
        })
    );
  };

  const handleCheckedModulo = (item, checked) => {
    if (item == "portalCheckBox") {
      moduloPortal = checked;
    }
    if (item == "galeriaCheckBox") {
      moduloGaleria = checked;
    }
  };

  useEffect(() => {
    if (idNotificacoesEdicao != undefined && idNotificacoesEdicao != null) {
      listaNotificacoes();
    }
  }, [idNotificacoesEdicao]);

  useEffect(() => {
    if (checkBoxAgendamento == false) {
      setDataHora({ data: "", hora: "" });
    }
  }, [checkBoxAgendamento]);
  return (
    <div className="col-md-9 col-sm-9 col-xl-9">
      <div className="row" style={{ borderBottom: "1px solid #898989" }}>
        <div
          style={{ padding: "0px" }}
          className="col-md-12 col-sm-12 col-xl-12 mb-3"
        >
          <span className="titulo-perm">Notificação</span>
        </div>
      </div>

      <div className="mt-3 titulosPermissoesNotificacoes">Informações</div>
      <Form form={form} layout="vertical" onFinish={onSubmit} className="mt-3">
        <Form.Item name="titulo" label="Título">
          <Input
            role={require}
            placeholder="Insira o título"
            className="input-usuario"
          />
        </Form.Item>
        <Form.Item name="subtitulo" label="Subtítulo">
          <Input
            role={require}
            placeholder="Insira o subtítulo"
            className="input-usuario"
          />
        </Form.Item>
        <Form.Item name="link" label="Link">
          <Input
            role={require}
            placeholder="Insira o link"
            className="input-usuario"
          />
        </Form.Item>
        <div className="mt-3 titulosPermissoesNotificacoes">Módulos</div>
        <br />
        <Form.Item name="portalCheckbox">
          <Checkbox
            checked={checkBoxPortal}
            onChange={(e) => {
              setCheckBoxPortal(!checkBoxPortal);
            }}
          />{" "}
          &nbsp;&nbsp;Portal do Varejo
        </Form.Item>
        <Form.Item name="galeriaCheckbox">
          <Checkbox
            checked={checkBoxGaleria}
            onChange={(e) => {
              setCheckBoxGaleria(!checkBoxGaleria);
            }}
          />{" "}
          &nbsp;&nbsp;Galeria de Mídia
        </Form.Item>
        <div className="mt-3 titulosPermissoesNotificacoes">
          Agendar notificação
        </div>
        <Form.Item name="galeriaCheckbox">
          <br></br>
          <Radio
            checked={!checkBoxAgendamento}
            onChange={(e) => {
              setCheckBoxAgendamento(!checkBoxAgendamento);
            }}
          />
          Não&nbsp;&nbsp;
          <Radio
            checked={checkBoxAgendamento}
            onChange={(e) => {
              setCheckBoxAgendamento(!checkBoxAgendamento);
            }}
          />
          Sim&nbsp;&nbsp;
        </Form.Item>

        <div className="dataHoraNotificacao">
          <div className="d-flex  flex-column ">
            <label>Data</label>
            <Input
              disabled={!checkBoxAgendamento}
              role={require}
              className="input-data label-dataHora-notificacao"
              type="date"
              value={checkBoxAgendamento ? dataHora.data : ""}
              onChange={(e) => {
                setDataHora((prev) => ({ ...prev, data: e.target.value }));
              }}
            />
          </div>

          <div className="d-flex  flex-column ">
            <label>Hora</label>
            <Input
              disabled={!checkBoxAgendamento}
              role={require}
              className="input-data label-dataHora-notificacao"
              type="time"
              value={checkBoxAgendamento ? dataHora?.hora : ""}
              onChange={(e) =>
                setDataHora((prev) => ({ ...prev, hora: e.target.value }))
              }
            />
          </div>
        </div>

        <Destinatarios
          setOrdenacao={setOrdenacao}
          ordenacao={ordenacao}
          setUsuariosRemovidos={setUsuariosRemovidos}
          setUsuariosDestinatarios={setUsuariosNotificacao}
          usuariosDestinatarios={usuarios}
          idNotificacoesEdicao={idNotificacoesEdicao}
        />
        <div className="d-flex justify-content-center mt-5">
          <button type="submit" className="btn-aplicarNotForm">
            {idNotificacoesEdicao ? "Aplicar" : "Enviar"}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default NotificacaoForm;
